import { render, staticRenderFns } from "./DocumentPOSTotalItems.vue?vue&type=template&id=316ff594"
import script from "./DocumentPOSTotalItems.vue?vue&type=script&lang=js"
export * from "./DocumentPOSTotalItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports